import React, { useEffect, useState } from "react";
import ScrollAnimation from "react-animate-on-scroll";
import "animate.css/animate.min.css";
import { apiCall, mediaUrl } from "../util";
import { Link } from "react-router-dom";
import { why_choose_section_bg, why_us} from "../Image";
// import aboutVideo from "../gokulam_images/sree_gokulam.mp4";
import axios from "axios";

const AboutUs = () => {
  const [data, setData] = useState(null);
  const [titledata, setTitleData] = useState();

  // const [videoLoaded, setVideoLoaded] = useState(false);

  // const handleVideoLoaded = () => {
  //   setVideoLoaded(true);
  // };

  useEffect(() => {
    const fetchAboutUsData = async () => {
      try {
        const response = await axios.get(apiCall + "about_us/getall");
        setData(response.data[0]);
      } catch (error) {
        console.error("Error fetching about us data:", error);
      }
    };
    fetchAboutUsData();
  }, []);

  return (
    <section className="p-0 appear anime-complete">
      <div className="container-fluid p-0">
        <div className="row justify-content-center justify-content-md-end g-0 flex-row-reverse">
          {/* Left Content with Scroll Animation */}
          <ScrollAnimation
            animateIn="animate__fadeInUp"
            animateOnce={true}
            duration={1.2}
            delay={0}
            className="col-lg-6 ps-8 pe-8 pt-6 pb-6 -xxl-p-5 sm-p-30px bg-sg-linen appear anime-child anime-complete"
          >
            <div className="d-flex align-items-center gap-2 mb-20px">
              <img src={why_us} className="h-60px" alt="" />
              <div>
                <span className="text-base-color fw-600 -mb-5px text-uppercase d-block">
                  About us
                </span>
                <h5 className="text-dark-gray fw-bold mb-0 ls-minus-1px">
                  Our{" "}
                  <span className="text-gradient-sg-red-purple">
                    Healthcare Story
                  </span>
                </h5>
              </div>
            </div>
            <p className="w-100 md-w-100 line-clamp-4">
              {data?.description ? data.description : "Loading description..."}
            </p>
            <Link
              to="/about-us"
              className="btn btn-gradient-sg-header d-table d-lg-inline-block lg-mb-15px sg-border-styled fw-600 pe-25px ps-25px"
            >
              Know more
              <i className="fa-solid fa-arrow-up-right-from-square"></i>
            </Link>
          </ScrollAnimation>

          {/* Right Content with Scroll Animation */}
          <ScrollAnimation
            animateIn="animate__fadeIn"
            animateOnce={true}
            duration={1.5}
            delay={0.2}
            className="col-lg-6 position-relative"
          >
            <div
              className="h-100 md-h-600px sm-h-450px cover-background overflow-visible"
              style={{
                backgroundImage: `url('${mediaUrl}/${data?.image}')`,
              }}
            ></div>
            {/* {!videoLoaded && (
              <img
                src={why_choose_section_bg}
                alt="Placeholder"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            )}
            <video
              src={aboutVideo}
              autoPlay
              muted
              loop
              playsInline
              onCanPlayThrough={handleVideoLoaded}
              style={{
                display: videoLoaded ? "block" : "none",
                width: "100%",
                height: "100%",
                objectFit: "cover",
                position: "absolute",
                top: 0,
                left: 0,
              }}
            /> */}
          </ScrollAnimation>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
